import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import WhatsAppIcon from "./WhatsAppIcon";
import { useSite } from "@/context/SiteContext";

export default function FloatingWhatsApp() {
  const { openQuote, quoteOpen } = useSite();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.button
      initial={false}
      animate={{ opacity: visible && !quoteOpen ? 1 : 0, scale: visible && !quoteOpen ? 1 : 0.6, pointerEvents: visible && !quoteOpen ? "auto" : "none" }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      onClick={() => openQuote({ source: "floating" })}
      className="group fixed bottom-[calc(0.9rem+env(safe-area-inset-bottom))] right-[calc(0.75rem+env(safe-area-inset-right))] z-40 flex items-center gap-2.5 sm:bottom-7 sm:right-7"
      aria-label="Cere ofertă pe WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <span className="hidden items-center border border-white/15 bg-ink-900/90 px-4 py-2.5 font-display text-base font-bold uppercase tracking-wider text-paper backdrop-blur-md transition-colors group-hover:border-copper group-hover:text-copper sm:flex">
        CERE OFERTĂ
      </span>
      <span className="relative inline-flex h-11 w-11 items-center justify-center rounded-full bg-wa text-white shadow-[0_6px_20px_rgba(37,211,102,0.35)] transition-transform duration-300 group-hover:scale-105 sm:h-14 sm:w-14">
        <span className="absolute inset-0 rounded-full bg-wa animate-pulse-ring" aria-hidden="true" />
        <WhatsAppIcon className="relative h-5 w-5 sm:h-7 sm:w-7" />
      </span>
    </motion.button>
  );
}
